<template>
  <div class="createPage">
    <!-- header start -->
    <van-nav-bar
      title="创建纪念馆"
      class="mynavbar"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <!-- header end -->

    <img src="@/assets/images/create/step02_bg.jpg" class="createBg" />

    <div class="block step03">
      <div class="setp03-box">
        <div class="field-item">
          <div class="hd">
            <img src="@/assets/images/create/m_jng_name.png" />
          </div>
          <div class="bd">
            <van-field v-model="mname" placeholder="纪念馆名称" />
          </div>
        </div>
        <div class="field-item" @click="selectTypeShow = true">
          <div class="hd">
            <img src="@/assets/images/create/m_jng_leibie.png" />
          </div>
          <div class="bd">
            <van-field v-model="selectType" readonly placeholder="纪念馆类别" />
          </div>
          <div class="ft"><van-icon name="arrow" color="#fff" size="16" /></div>
        </div>
      </div>

      <div class="btn-area">
        <van-button round plain class="whitebtn minbtn" @click="finish" replace
          >完成</van-button
        >
      </div>
    </div>

    <!-- 纪念馆类别 popup start -->
    <van-popup v-model="selectTypeShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="['私人馆']"
        cancel-button-text=""
        confirm-button-text="确定"
        :visible-item-count="3"
        :default-index="0"
        @confirm="selectTypeShow = false"
        @cancel="selectTypeShow = false"
        @change="onTypeChange"
      />
    </van-popup>
    <!-- 纪念馆类别 popup end -->
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      isPersonOne: true,
      selectType: "私人馆",
      selectTypeShow: false,
      currenDate: new Date(),
      maxDate: new Date(),
      startDateShow: false,
      startDate: "",
      endDateShow: false,
      endDate: "",
      first: null,
      second: null,
      peopleCount: 1,
      mname: "",
      memorialHallType: 0,
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onTypeChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      this.selectType = value;
      this.memorialHallType = index;
    },
    finish() {
      // to="/CreateSuccess"
      var that = this;
      if (!that.first) {
        that.$router.replace({ name: "Home" });
        return;
      }
      if (!this.mname || this.mname.length == 0) {
        Toast("请输入纪念馆名称");
        return;
      }

      var options = {
        type: "MemorialManageAddMemorialVue",
        Title: that.mname,
        MemorialHallType: that.memorialHallType + 1,
        PeopleCount: that.peopleCount,
        FirstFullName: that.first.FirstFullName,
        FirstGender: that.first.FirstGender,
        FirstBirthdayDateTime: that.first.FirstBirthdayDateTime,
        FirstPassAwayDateTime: that.first.FirstPassAwayDateTime,
        FirstImg: that.first.FirstImg,
        FirstBirthdayDateMode: that.first.FirstBirthdayDateMode,
        FirstNlBirthdayList: that.first.FirstNlBirthdayList,
        FirstPassAwayDateMode: that.first.FirstPassAwayDateMode,
        FirstNlPassAwayList: that.first.FirstNlPassAwayList
      };
      if (that.second) {
        Object.assign(options, {
          SecondFullName: that.second.SecondFullName,
          SecondGender: that.second.SecondGender,
          SecondBirthdayDateTime: that.second.SecondBirthdayDateTime,
          SecondPassAwayDateTime: that.second.SecondPassAwayDateTime,
          SecondBirthdayDateMode: that.second.SecondBirthdayDateMode,
          SecondNlBirthdayList: that.second.SecondNlBirthdayList,
          SecondPassAwayDateMode: that.second.SecondPassAwayDateMode,
          SecondNlPassAwayList: that.second.SecondNlPassAwayList,
          SecondImg: that.second.SecondImg
        });
      }
      console.log(options,"options");
      that.$store.dispatch(options).then(
        (res) => {
          // console.log(res);
          if (res.IsSuccess) {
            var tempData = res.Information.split(",");
            that.$router.replace({
              name: "CreateSuccess",
              params: {
                uid: tempData[0],
                id: tempData[1],
                message: res.Message,
              },
            });
          }
        },
        (err) => {}
      );
    },
  },
  created() {
    var that = this;
    this.first = this.$route.params.first;
    this.second = this.$route.params.second;
    this.peopleCount = this.$route.params.peopleCount;
  },
};
</script>

<style scoped>
.setp03-box {
  padding-top: 25%;
}
</style>
